import 'angular:locale/data:de';
import 'angular:locale/data:en';
import 'zone.js';
import './projects/app-parashift-io/src/polyfills.ts';(globalThis.$localize ??= {}).locale = "___NG_LOCALE_INSERT___";
